import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { FlightsManagerMobile } from '../FlightsManager';
import { DynpackManagerMobile } from '../DynpackManager';
import { HotelManagerMobile } from '../HotelManager';
import { SearchManager } from './SearchManager';
import { EntryPoint, EntryPointProp, EntryPointPropDefault } from '../../models';
import { isLoggedIn } from '../../redux/userAuthentication/actions';
import { userAuthenticationSelector } from '../../redux/userAuthentication/selectors';
import { propagateLoginStatusToOdigeoJS } from '../../utils/OdigeoInteractions';
import { PixelTracking } from '../../components/PixelTracking';

export const SearchManagerMobile = ({ isHotelOptionEnabled, entryPoint, rootDataAttr }) => {
    const dispatch = useDispatch();
    const {
        usersResponse,
        initial: initialUsersResponse,
        isFetching: isFetchingUsersResponse,
    } = useSelector((state) => userAuthenticationSelector(state));
    const isUserLoggedIn = Object.keys(usersResponse).length !== 0 && usersResponse?.userDTO !== null;

    useEffect(() => {
        !initialUsersResponse && !isFetchingUsersResponse && propagateLoginStatusToOdigeoJS(isUserLoggedIn, usersResponse);
    }, [initialUsersResponse, isFetchingUsersResponse, isUserLoggedIn, usersResponse]);
    useEffect(() => {
        dispatch(isLoggedIn());
    }, []);
    switch (entryPoint) {
        case EntryPoint.DP:
            return (
                <SearchManager>
                    <PixelTracking entryPoint={entryPoint} />
                    <DynpackManagerMobile rootDataAttr={rootDataAttr} />
                </SearchManager>
            );
        case EntryPoint.HOTELS:
            return (
                <SearchManager>
                    <PixelTracking entryPoint={entryPoint} />
                    <HotelManagerMobile rootDataAttr={rootDataAttr} />
                </SearchManager>
            );
        case EntryPoint.TRAINS:
            return (
                <SearchManager>
                    <FlightsManagerMobile isHotelOptionEnabled={false} rootDataAttr={rootDataAttr} />
                </SearchManager>
            );
        default:
            return (
                <SearchManager>
                    <PixelTracking entryPoint={entryPoint} />
                    <FlightsManagerMobile isHotelOptionEnabled={isHotelOptionEnabled} rootDataAttr={rootDataAttr} />
                </SearchManager>
            );
    }
};

SearchManagerMobile.propTypes = {
    isHotelOptionEnabled: PropTypes.bool,
    entryPoint: EntryPointProp,
    rootDataAttr: PropTypes.object,
};

SearchManagerMobile.defaultProps = {
    isHotelOptionEnabled: false,
    entryPoint: EntryPointPropDefault,
    rootDataAttr: {},
};
